import React from "react";
import { CircularProgress } from "@mui/material";

const CircleLoader = (props) => (
  <div className="loading_parent">
    <CircularProgress {...props} />
  </div>
);
export default CircleLoader;
